var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-recipe-button-wrapper"},[_c('ica-save-recipe-button',{attrs:{"button-size":_vm.buttonSize},model:{value:(_vm.isSavedComponent),callback:function ($$v) {_vm.isSavedComponent=$$v},expression:"isSavedComponent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }